function EditerItem(data){
    return (
        <div className={`editerBox ${data.addClass||""}`} dangerouslySetInnerHTML={{__html:data.contents}}/>
    );
}

export {EditerItem};